<div class="app-dialog">
  <header class="app-dialog__header">
    <div class="app-dialog__header-text">
      <h2>{{ 'reseller.addClientTitle' | translate: { domain: data.resellerDomain } }}</h2>
    </div>
    <button mat-icon-button type="button" (click)="onCancel()" [attr.aria-label]="'cancel' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="app-dialog__body">
    <form [formGroup]="form" class="add-subdomain-form">
      <div class="form-field">
        <label class="field-label">{{ 'client.domain' | translate }}</label>
        <mat-form-field appearance="outline">
          <input type="text" matInput formControlName="domain" [errorStateMatcher]="errorStateMatcher">
          <mat-error *ngIf="form.hasError('required', ['domain'])">
            {{ 'fieldRequired' | translate }}
          </mat-error>
          <mat-error *ngIf="form.hasError('httpExists', ['domain'])">
            {{ 'domainWithoutHttp' | translate }}
          </mat-error>
        </mat-form-field>
      </div>

      <div class="form-field">
        <label class="field-label">{{ 'client.googleAdminEmail' | translate }}</label>
        <mat-form-field appearance="outline">
          <input type="email" matInput formControlName="googleAdminEmail" [errorStateMatcher]="errorStateMatcher">
          <mat-error *ngIf="form.hasError('required', ['googleAdminEmail'])">
            {{ 'fieldRequired' | translate }}
          </mat-error>
        </mat-form-field>
      </div>

      <div class="form-field">
        <label class="field-label">{{ 'client.trialFinishDate' | translate }}</label>
        <mat-form-field appearance="outline">
          <input matInput [matDatepicker]="picker" formControlName="trialFinishDate" [errorStateMatcher]="errorStateMatcher">
          <mat-hint>YYYY-MM-DD</mat-hint>
          <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
          <mat-error *ngIf="form.hasError('required', ['trialFinishDate'])">
            {{ 'fieldRequired' | translate }}
          </mat-error>
          <mat-error *ngIf="form.hasError('dateInvalid', ['trialFinishDate'])">
            {{ 'futureDateInvalid' | translate }}
          </mat-error>
        </mat-form-field>
      </div>

      <div class="checkbox-wrapper">
        <mat-checkbox formControlName="isIncludedDemoContent" color="primary">
          {{ 'client.includeDemoContent' | translate }}
        </mat-checkbox>
      </div>
    </form>
  </div>

  <footer class="app-dialog__footer">
    <button mat-stroked-button type="button" (click)="onCancel()" [disabled]="loading">{{ 'cancel' | translate }}</button>
    <button
      mat-raised-button
      color="primary"
      type="button"
      (click)="onSubmit()"
      [disabled]="loading">
      <mat-spinner diameter="20" class="dc-btn-spinner" *ngIf="loading"></mat-spinner>
      <mat-icon *ngIf="!loading">add</mat-icon>
      <span *ngIf="!loading">{{ 'add' | translate }}</span>
    </button>
  </footer>
</div>
